var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97195 0 0 8.97195 0 20C0 31.028 8.97195 40 20 40C31.028 40 40 31.028 40 20C40 8.97195 31.028 0 20 0ZM20 37.6562C10.2643 37.6562 2.34375 29.7357 2.34375 20C2.34375 10.2643 10.2643 2.34375 20 2.34375C29.7357 2.34375 37.6562 10.2643 37.6562 20C37.6562 29.7357 29.7357 37.6562 20 37.6562Z",
    fill: "#1BA7E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.6875C11.5566 4.6875 4.6875 11.5566 4.6875 20C4.6875 28.4434 11.5566 35.3125 20 35.3125C28.4434 35.3125 35.3125 28.4434 35.3125 20C35.3125 11.5566 28.4434 4.6875 20 4.6875ZM20 32.9688C12.849 32.9688 7.03125 27.151 7.03125 20C7.03125 12.849 12.849 7.03125 20 7.03125C27.151 7.03125 32.9688 12.849 32.9688 20C32.9688 27.151 27.151 32.9688 20 32.9688Z",
    fill: "#1BA7E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3412 13.3154L26.684 11.6582L19.9995 18.3426L13.3428 11.6859L11.6855 13.3431L18.3423 19.9998L16.685 21.6571L18.3423 23.3144L19.9995 21.6571L21.6568 23.3144L23.3141 21.6571L21.6568 19.9998L28.3412 13.3154Z",
    fill: "#1BA7E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8281 9.375H21.1719V11.7187H18.8281V9.375Z",
    fill: "#1BA7E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8281 28.2812H21.1719V30.625H18.8281V28.2812Z",
    fill: "#1BA7E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 18.8281H11.7188V21.1719H9.375V18.8281Z",
    fill: "#1BA7E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2812 18.8281H30.625V21.1719H28.2812V18.8281Z",
    fill: "#1BA7E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f6811ef702b42215774952c9944c1c5c.svg";
export { ForwardRef as ReactComponent };